import withSharedStyles from "../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => ({
  root: {
    boxShadow: theme.tokens.shadow.hairline,
    borderRadius: theme.tokens.radius.card,
    padding: 24,
    minHeight: "300px"
  },
  cardMedia: {
    width: "100%",
    height: "45vh",
    objectFit: "initial",
    [theme.media.tabletUp]: {
      height: "55vh"
    },
    [theme.media.desktop]: {
      width: "auto",
      height: "65vh"
    }
  },
  breadCrumbs: {
    padding: "16px 0"
  },
  loadMore: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    position: "relative",
    padding: 24,
    width: "100%",
    height: "inherit",
    backgroundColor: "transparent"
  }
}));

export default withCustomStyles;
